import { useQuery } from '@tanstack/react-query'
import { getDesk } from './api'

/** The title's "Imports on" switch, read from the desk query the layout already caches. Off until it loads. */
export function useImportsOn(slug: string | undefined): boolean {
  const q = useQuery({ queryKey: ['editorial-desk', slug], queryFn: () => getDesk(slug as string), enabled: !!slug, staleTime: 30_000, retry: false })
  return q.data?.imports_on === true
}
